import { DotsHorizontalIcon } from "@heroicons/react/solid";
import axios from "axios";
import { Markup } from "interweave";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import ShowMoreText from "react-show-more-text";
import shakibUser from "../../../Assets/Images/cricket.jpg";
import Share from "../../../Assets/Images/share.png";
import ShareB from "../../../Assets/Images/ShareB.png";
import SingleAuditionPost from "../../../Screen/Post/SingleAuditionPost";
import SingleGeneralPost from "../../../Screen/Post/SingleGeneralPost";
import SingleLearningSession from "../../../Screen/Post/SingleLearningSession";
import SingleLiveChatPost from "../../../Screen/Post/SingleLiveChatPost";
import SingleMeetupPost from "../../../Screen/Post/SingleMeetupPost";
import SingleQnA from "../../../Screen/Post/SingleQnA";
import AuctionSearch from "./Content/AuctionSearch/AuctionSearch";
import FanGroupSearch from "./Content/FanGroupSearch/FanGroupSearch";
import MarketplaceSearch from "./Content/MarketPlaceSearch/MarketPlaceSearch";
import PostSearch from "./Content/PostSearch/PostSearch";
import StarShowcaseSearch from "./Content/StarShowcaseSearch/StarShowcaseSearch";
import "./SerachUser.css";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { serverInfo } from "../../../App";
import DogWithBoll from "../../../Assets/Images/dogwithball.gif";

// import { SearchSlug } from "./../../../../src/CustomHelper/Helper";

const SearchUser = () => {


  const { imageCdnUrl } = useContext(serverInfo);



  // const {slug} = useParams();
  const searchSlug = JSON.parse(localStorage.getItem("searchSlug"));
  //localStorage.removeItem('searchSlug');
  // const [checkSlug, setCheckSlug] = useState('');

  const [searchSuperstar, setSearchSuperstar] = useState([]);
  const [searchPosts, setSearchPosts] = useState([]);
  const [searchMarketplace, setSearchMarketplace] = useState([]);
  const [searchAuction, setSearchAuction] = useState([]);
  const [searchSouvenir, setSearchSouvenir] = useState([]);
  const [searchFanGroup, setSearchFanGroup] = useState([]);
  const [searchEnd, setSearchEnd] = useState(false);

  const [searchSuggSuperstar, setSearchSuggSuperstar] = useState([]);
  const [searchSuggPosts, setSearchSuggPosts] = useState([]);
  const [searchSuggMarketplace, setSearchSuggMarketplace] = useState([]);
  const [searchSuggAuction, setSearchSuggAuction] = useState([]);
  const [searchSuggSouvenir, setSearchSuggSouvenir] = useState([]);
  const [searchSuggFanGroup, setSearchSuggFanGroup] = useState([]);

  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // const cat_slug = props.match.params.slug;

    // setCheckSlug(searchSlug);

    axios.get(`/api/user/search/${searchSlug}`).then((res) => {
      if (res.data.status === 200) {
        setSearchSuperstar(res.data?.superstar);
        setSearchPosts(res.data?.posts);
        setSearchMarketplace(res.data?.marketplace);
        setSearchAuction(res.data?.auction);
        setSearchSouvenir(res.data?.souvenir);
        setSearchFanGroup(res.data?.fangroup);
        setSearchEnd(true)
        // Search Superstar using filter
        const getSearchSuperstar = res.data?.superstar.filter((item) => {
          return (
            item?.first_name?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.last_name?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.first_name
              ?.concat(" ", item?.last_name)
              .toLowerCase()
              .includes(searchSlug.toLowerCase())
          );
        });
        setSearchSuggSuperstar(getSearchSuperstar);

        // Search Post using filter
        const getSearchPosts = res.data?.posts.filter((item) => {
          return (
            // item.title.toLowerCase().includes(searchSlug.toLowerCase()) ||
            (item.title != null ? item.title : " ")
              ?.toLowerCase()
              .includes(searchSlug.toLowerCase()) ||
            item?.type?.toLowerCase().includes(searchSlug.toLowerCase())
            // item.details.toLowerCase().includes(searchSlug.toLowerCase())
          );
        });
        setSearchSuggPosts(getSearchPosts);

        // Search Marketplace using filter
        const getSearchMarketplace = res.data?.marketplace.filter((item) => {
          return (
            item?.title?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.description?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.terms_conditions
              ?.toLowerCase()
              .includes(searchSlug.toLowerCase()) ||
            item?.keywords?.toLowerCase().includes(searchSlug.toLowerCase())
          );
        });
        setSearchSuggMarketplace(getSearchMarketplace);

        // Search Auction using filter
        const getSearchAuction = res.data?.auction.filter((item) => {
          return (
            item?.title?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.details?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.keyword?.toLowerCase().includes(searchSlug.toLowerCase())
          );
        });
        setSearchSuggAuction(getSearchAuction);

        // Search Souvenir using filter
        const getSearchSouvenir = res.data?.souvenir.filter((item) => {
          return (
            item?.description?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.title?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.instruction?.toLowerCase().includes(searchSlug.toLowerCase())
          );
        });
        setSearchSuggSouvenir(getSearchSouvenir);

        // Search Fan Group using filter
        const getSearchFanGroup = res.data?.fangroup.filter((item) => {
          return (
            item?.description?.toLowerCase().includes(searchSlug.toLowerCase()) ||
            item?.group_name?.toLowerCase().includes(searchSlug.toLowerCase())
          );
        });
        setSearchSuggFanGroup(getSearchFanGroup);
      }
    });
    setLoading(false);
    // localStorage.removeItem("searchSlug");
  }, [searchSlug]);

  useEffect(() => {
    setSearchSuggSuperstar("");
    setSearchSuggPosts("");
    setSearchSuggMarketplace("");
    setSearchSuggAuction("");
    setSearchSuggSouvenir("");
    setSearchSuggFanGroup("");

    // Search Superstar using filter
    const getSearchSuperstar = searchSuperstar.filter((item) => {
      return (
        item?.first_name?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.last_name?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.first_name
          ?.concat(" ", item?.last_name)
          .toLowerCase()
          .includes(searchSlug.toLowerCase())
      );
    });
    setSearchSuggSuperstar(getSearchSuperstar);

    // Search Post using filter
    const getSearchPosts = searchPosts.filter((item) => {
      return (
        // item.title.toLowerCase().includes(searchSlug.toLowerCase()) ||
        (item.title != null ? item.title : " ")
          .toLowerCase()
          .includes(searchSlug.toLowerCase()) ||
        item?.type?.toLowerCase().includes(searchSlug.toLowerCase())
        // item.details.toLowerCase().includes(searchSlug.toLowerCase())
      );
    });
    setSearchSuggPosts(getSearchPosts);

    // Search Marketplace using filter
    const getSearchMarketplace = searchMarketplace.filter((item) => {
      return (
        item?.title?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.description?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.terms_conditions
          ?.toLowerCase()
          .includes(searchSlug.toLowerCase()) ||
        item?.keywords?.toLowerCase().includes(searchSlug.toLowerCase())
      );
    });
    setSearchSuggMarketplace(getSearchMarketplace);

    // Search Auction using filter
    const getSearchAuction = searchAuction.filter((item) => {
      return (
        item?.title?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.details?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.keyword?.toLowerCase().includes(searchSlug.toLowerCase())
      );
    });
    setSearchSuggAuction(getSearchAuction);

    // Search Souvenir using filter
    const getSearchSouvenir = searchSouvenir.filter((item) => {
      return (
        item?.description?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.title?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.instruction?.toLowerCase().includes(searchSlug.toLowerCase())
      );
    });
    setSearchSuggSouvenir(getSearchSouvenir);

    // Search Fan Group using filter
    const getSearchFanGroup = searchFanGroup.filter((item) => {
      return (
        item?.description?.toLowerCase().includes(searchSlug.toLowerCase()) ||
        item?.group_name?.toLowerCase().includes(searchSlug.toLowerCase())
      );
    });
    setSearchSuggFanGroup(getSearchFanGroup);
  }, [searchSlug]);

  return (
    <>
      { searchSuggSuperstar.length > 0 ||
        searchSuggPosts.length > 0 ||
        searchSuggMarketplace.length > 0 ||
        searchSuggAuction.length > 0 ||
        searchSuggSouvenir.length > 0 ||
        searchSuggFanGroup.length > 0 ? (

        <div className="my-2">
          {searchSuggSuperstar.length > 0 ? (
            <div className="searchUserFirst">
              <h6 className="mx-3 py-2 text-light">Star/ People</h6>
              <div className="underLineBlackSearch"></div>
              {searchSuggSuperstar?.map((star) => (
                <div className="row my-1 d-flex justify-content-between pe-2">
                  <div className="col-md-9">
                    <div className="d-flex mx-3 p-2">
                      <img
                        src={
                          star?.image ? imageCdnUrl + star?.image : shakibUser
                        }
                        className="peoplePhotoAvatar img-fluid"
                        alt=""
                      />
                      <div className="text-light mx-2">
                        <h4>
                          {star?.first_name} {star?.last_name}
                        </h4>
                        <p>@Superstar</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3  d-flex justify-content-end align-items-center pe-5 mb-2">
                    <Link to={`/starprofile/${star?.id}`}>
                      <button className="btnFollow">View</button>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            ""
          )}

          {searchSuggPosts.length > 0 ? (
            <div className="searchUserFirst my-3">
              <h6 className="mx-3 py-2 text-light">Post</h6>
              <div className="underLineBlackSearch"></div>

              {searchSuggPosts?.map((post) =>
                post.type === "meetup" ? (
                  <SingleMeetupPost post={post} />
                ) : post.type === "livechat" ? (
                  <SingleLiveChatPost post={post} />
                ) : post.type === "qna" ? (
                  <SingleQnA post={post} />
                ) : post.type === "learningSession" ? (
                  <SingleLearningSession post={post} />
                ) : post.type === "audition" ? (
                  <SingleAuditionPost post={post} />
                ) : post.type === "general" ? (
                  <SingleGeneralPost post={post} />
                ) : null
              )}
            </div>
          ) : null}

          {searchSuggFanGroup.length > 0 ? (
            <FanGroupSearch searchSuggFanGroup={searchSuggFanGroup} />
          ) : null}

          {searchSuggSouvenir.length > 0 ? (
            <StarShowcaseSearch searchSuggSouvenir={searchSuggSouvenir} />
          ) : null}

          {/* {
        searchMarketplace.map((marketplace) =>( */}
          {searchSuggMarketplace.length > 0 ? (
            <MarketplaceSearch searchSuggMarketplace={searchSuggMarketplace} />
          ) : null}
          {/* ))} */}

          {searchSuggAuction.length > 0 ? (
            <AuctionSearch searchSuggAuction={searchSuggAuction} />
          ) : null}
        </div>
      ) : (
              !searchEnd ||
              searchSuggSuperstar.length > 0 ||
              searchSuggPosts.length > 0 ||
              searchSuggMarketplace.length > 0 ||
              searchSuggAuction.length > 0 ||
              searchSuggSouvenir.length > 0 ||
              searchSuggFanGroup.length > 0 ? (
              <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  {[1, 2, 3, 4].map((data) => (
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="rounded">
                          <div className="bg-dark py-3 px-2 text-center">
                            <Skeleton width="100%" height={250} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-md-6">
                        <div className="rounded">
                          <div className="bg-dark py-3 px-2">
                            <Skeleton width="100%" height={70} />
                            <Skeleton width="50%" height={50} />
                            <br />
                            <div className="row">
                              <div className="col-md-2">
                                <Skeleton circle height="60px" width="60px" />
                              </div>
                              <div className="col-md-10">
                                <Skeleton width="100%" className="" height={55} />
                              </div>
                            </div>

                            <Skeleton width="100%" className="" height={35} />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </SkeletonTheme>
                 ):(<div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
            >
              <img src={DogWithBoll} style={{ height: 250, width: 500 }} />
              <h4 className="text-center text-warning">
                Sorry, No Search Result Found
              </h4>
            </div>)
               )}
    </>
  );
};

export default SearchUser;
